class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
// Variant choose option for cart recommendation's product card
$(document).on('cartdrawer:opened', function() {
  $(document).on('change', 'cart-recommendations [id^="variant-select-"]', function() {
    let recId = $(this).data('recommendation-id');
    let btn = $(this).closest('.product-button').find('add-to-cart[data-recommendation-id="' + recId + '"]');
    btn.attr('data-variant-id', $(this).val());
  });
});